import React from 'react';
import Head from 'next/head';
import Header from './../../components/Header';
import Footer from './../../components/Footer';
import ArticleCard from './../../components/ArticleCard';

import { articles } from '../../data/articles';


const Articles = ({ }) => {
    return (
        <div className="flex flex-col min-h-screen justify-between">
            <Head>
                <title>IELTS preparation materials</title>
                <meta name="description" content="Discover our latest articles on IELTS preparation and strategies." />
            </Head>

            <Header />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
                {articles.map((article) => (
                    <ArticleCard
                        key={article.id}
                        title={article.title}
                        summary={article.summary}
                        imgSrc={article.imgSrc}
                        link={article.link}
                    />
                ))}
            </div>

            <Footer />
        </div>
    );
};

export default Articles;
